export default __webpack_public_path__ + "static/media/ksivalue_main_mobile_small@2x.611c7895.jpg";